import React from "react";
import { compose } from "recompose";
import { withStyles, Grid, FormControlLabel, Checkbox} from "@material-ui/core";
import Select from "../../../common/StyledSelect";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import appConstants from "../../../../appConstants.js";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { withSnackbar } from "notistack";
import ChartComponent from "./Chart/ChartComponent";
import StyledCalendar from "./StyledCalendar";
import RouteChart from "./Chart/RouteChart";
import chartConfig from "./ChartConfig";
import {
  prepareBillData,
  getModuleList,
  renameKeyAndMergeObject,
  getFormattedPlanDate,
} from "./utils/utils";
import {
  modifyEmptyChartData,
  removeTrapRoute,
  timeConvert,
} from "./formatEmptyTimeData";
import { RMAXLogger } from "../../../../services/LoggerService/RMAXLogger";
import { withAppConfig } from "../../../../appConfigContext";
const [Planning, Dispatch] = appConstants.MODULES;

const styles = (theme) => ({
  selectFilterClass: {
    display: "flex",
    direction: "column",
    width: "180px !important",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  formLabel: {
    padding: "5px 0px",
    fontWeight: "bold",
    fontSize: "12px",
    color: theme.gridIconBorderColor,
    margin: 0,
  },
  formLabelGreen: {
    padding: "0px",
    fontWeight: "bold",
    fontSize: "12px",
    color: theme.HeaderSelectedText,
    margin: 0,
  },
  container: {
    fontSize: "12px",
  },
  lineLabel: {
    padding: "5px 5px",
    fontSize: "12px",
    margin: 0,
    display: "inline-block",
    color: theme.TextColor,
  },
  chartLabel: {
    padding: "0px",
    fontWeight: "bold",
    fontSize: "14px",
    margin: 0,
    display: "flex",
    justifyContent: "center",
    marginTop: "15px",
    color: theme.TextColor,
  },
  checkBoxColor: {
    color: theme.gridTextColor
  },
  checkBoxLabelStyle: {
    color: theme.TextColor,
  },
  subModuleRight: {
    width: "100%",
    maxHeight: "100%",
    overflowY: "auto",
    overflowX: "hidden",
  },
  chartContainer: {
    width: "90%",
    minHeight: "400px",
  },
  infoMessage: {
    color: theme.disableButtonText,
    fontSize: theme.textFontSize,
    marginLeft: 20
  }
});

class KPISummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: {},
      routeChartData: {},
      terminalList: [],
      terminalId: "",
      terminalCode: "",
      selectedDate: [],
      activeSection: 0,
      activeChart: "",
      totalBills: [],
      emptyTimeData: [],
      planDate: null,
      modules: []
    };
  }

  componentDidMount() {
    this._isComponentMounted = true;
    RMAXLogger.info("KPIReportHome");
    this.getTerminalList();
    this.setState({
      selectedDate: [this.getDate(-15), new Date()],
      modules: getModuleList(this.props.configJSON.enableDispatch)
    });
  }

  componentWillUnmount() {
    this._isComponentMounted = false;
  }
  //get date value
  getDate = (value) => {
    let startDate = new Date();
    startDate.setDate(startDate.getDate() + value);
    return startDate;
  };
  //get KPi summary data
  GetKPIReportForRoutes = (planDate) => {
    const promises = [
      getDataWithQueryString("GetPlanningKPIReportForRoutes",
        `planDate=${getFormattedPlanDate(planDate)}&terminalId=${this.state.terminalId}`)
    ];    
    if (this.props.configJSON.enableDispatch) {
      promises.push(
        getDataWithQueryString("GetDispatchKPIReportForRoutes",
          `dispatchDate=${getFormattedPlanDate(planDate)}&terminalCode=${this.state.terminalCode}`), //TODO Dispatch API dont support terminalId
      );
    }    
    Promise.allSettled(promises).then(results => {
      const [planningModuleRes, dispatchModuleRes] = results;    
      const resData = {planningData: planningModuleRes?.value?.data ?? [], dispatchData: dispatchModuleRes?.value?.data ?? []}
      if (this._isComponentMounted) {
        if (planningModuleRes?.value?.status === 200 || dispatchModuleRes?.value?.status === 200) {
          if (this.state.activeChart == "Routes") {
            const data = modifyEmptyChartData(removeTrapRoute(resData));
            this.setState({ routeChartData: data, planDate: planDate });
          } else if (this.state.activeChart == "Total hours") {
            const data = timeConvert(removeTrapRoute(resData));
            this.setState({ routeChartData: data, planDate: planDate });
          } else {
            this.setState({
              routeChartData: removeTrapRoute(resData),
              planDate: planDate,
            });
          }
        } else {
          this.setState({
            routeChartData: {},
          });
          this.props.enqueueSnackbar('Error fetching Chart Data', {
            variant: "error",
          });
        }
      }
    });
  };

  GetKPIReportCharts = () => {
    const promises = [
      getDataWithQueryString("GetPlanningKPIReportCharts",
        `startDate=${getFormattedPlanDate(this.state.selectedDate[0])}&endDate=${
          getFormattedPlanDate(this.state.selectedDate[1])}&terminalCode=${this.state.terminalCode}&terminalId=${this.state.terminalId}`)
    ];    
    if (this.props.configJSON.enableDispatch) {
      promises.push(
        getDataWithQueryString("GetDispatchKPIReportCharts",
          `startDate=${getFormattedPlanDate(this.state.selectedDate[0])}&endDate=${
            getFormattedPlanDate(this.state.selectedDate[1])}&terminalCode=${this.state.terminalCode}`)
      );
    }    
    Promise.allSettled(promises).then(results => {
      const [planningModuleRes, dispatchModuleRes] = results;    
      if (this._isComponentMounted) {
        if (planningModuleRes?.value?.status === 200 || dispatchModuleRes?.value?.status === 200) {
          const chartData = {
            planningData: planningModuleRes?.value?.data ?? [],
            dispatchData: dispatchModuleRes?.value?.data ?? []
          }
          this.setState({chartData});
          this.calculateTotalBill( prepareBillData(chartData));
        } else {
          this.setState({ chartData: {}});
          this.props.enqueueSnackbar(`Error fetching Chart Data`, {
            variant: "error",
          });
        }
      }
    });
  };

  /*
    calculating total bill for a module, it accept totalBill and deliveryBill of a module
    and return array of object having planDate to totalBill mapping.
  */
  getTotalBillForModule = ({totalBill, deliveryBills}) => {
    const billList = [...totalBill]
    billList?.forEach((element) => {
      deliveryBills.forEach((db) => {
        if (element.planDate === db.planDate) {
          (element.value = element.value - db.value),
            (element["goal"] = db.value);
        }
      });
    });
    return billList
  }

  calculateTotalBill = (billData) => {
    let totalBills = []
    billData.forEach(moduleBill => {
      totalBills.push({
        name: moduleBill.name,
        data: this.getTotalBillForModule(moduleBill),
      })
    })
    this.setState({ totalBills });
  };
  //back from other view
  goBack = () => {
    this.setState((state) => ({
      activeSection: state.activeSection - 1,
      routeChartData: {},
      totalBills: [],
      emptyTimeData: [],
    }));
  };
  //get terminal list
  getTerminalList = () => {
    const userId = this.props.userData.userProfile.userId;
    const { code: currentTerminalCode, id: currentTerminalId } = this.props.userData.userProfile.terminal;
    getDataWithQueryString("GetAllTerminals", `userId=${userId}`).then(
      (response) => {
        if (this._isComponentMounted) {
          if (response && response.status >= 200 && response.status < 400) {
            this.setState({
              terminalList: response.data.map((terminal) => ({
                value: terminal.terminalId,
                label: terminal.terminalCode,
              })),
            });
            if (!this.state.terminalCode) {
              this.setState({
                terminalCode: currentTerminalCode ?? this.state.terminalList[0].label,
                terminalId: currentTerminalId ?? this.state.terminalList[0].value
              });
            }
          } else {
            this.setState({
              terminalList: [],
            });
            this.props.enqueueSnackbar(`Error fetching terminal list`, {
              variant: "error",
            });
          }
        }
      },
      (error) => {
        if (this._isComponentMounted) {
          this.setState({
            terminalList: [],
          });
          this.props.enqueueSnackbar(`Error fetching terminal list`, {
            variant: "error",
          });
        }
      }
    );
  };

  // Clear user value in the field
  clearField = (field) => (event) => {
    this.handleChange(field)("");
  };
  // Update terminalId on terminal select
  handleChange = (name) => (value) => {
    if (name === "DateRange") {
      this.setState({
          selectedDate: value,
        }, () => {
          this.GetKPIReportCharts();
        }
      );
    } else if (name === "selectedTerminal") {
      this.setState({
          terminalId: value.value,
          terminalCode: value.label,
        }, () => {
          this.GetKPIReportCharts();
        }
      );
    } else if (name === "selectedModule") {
        let newList=[]
        this.state.modules.forEach(module => {
          if (module.name === value.target.name) {
              newList.push({...module, isChecked: value.target.checked})
          } else {
            newList.push({...module})
          }
        })
        RMAXLogger.info("KPIReportModuleSelection", {moduleName: value.target.name});
        this.setState({modules: newList})
    }
  };

  // for fetching detail chart report
  fetchReport = (props) => {
    const isPlanning = props.activePayload[0].payload[`${Planning}_kpiName`] !== undefined
    const activeChart = isPlanning
      ? props.activePayload[0].payload[`${Planning}_kpiName`]
      : props.activePayload[0].payload[`${Dispatch}_kpiName`]
    if (!props?.activeLabel) return
    this.GetKPIReportForRoutes(props.activeLabel);
    this.setState({ activeSection: 1, activeChart });
  };

  filterModuleData = (data, moduleName) => {
    return data.find(el => el.name === moduleName)?.data ?? []
  }

  getModuleCheckboxValue = (data, moduleName) => {
    return data.find(el => el.name === moduleName)?.isChecked
  }

  getFormatedChartData = (kpiName) => {
    return [{
      name: Planning,
      data: this.state.chartData?.planningData?.[kpiName] ?? [],
      isChecked: this.getModuleCheckboxValue(this.state.modules, Planning)
    },
    {
      name: Dispatch,
      data: this.state.chartData?.dispatchData?.[kpiName] ?? [],
      isChecked: this.getModuleCheckboxValue(this.state.modules, Dispatch)
    }]
  }

  getFormatedTotalBillData = () => {
    if (this.state.totalBills.length!==0) {
      const data = [{
        name: Planning,
        data: this.filterModuleData(this.state.totalBills, Planning),
      },
      {
        name: Dispatch,
        data: this.filterModuleData(this.state.totalBills, Dispatch),
      }]
      return renameKeyAndMergeObject({data, groupBy: "planDate"})
    }
  }

  getFormatedReportForRoutesData = ({isPlanningChecked, isDispatchChecked}) => {
    let data = []
    isPlanningChecked && this.state.routeChartData?.planningData &&
      data.push({
        name: Planning,
        data: this.state.routeChartData?.planningData ?? [],
      })
    isDispatchChecked && this.state.routeChartData?.dispatchData &&
      data.push({
        name: Dispatch,
        data: this.state.routeChartData?.dispatchData ?? [],
      })
    return renameKeyAndMergeObject({data})
  }

  getCheckboxStatus = () => {
    return {
      isPlanningChecked: this.getModuleCheckboxValue(this.state.modules, Planning),
      isDispatchChecked: this.getModuleCheckboxValue(this.state.modules, Dispatch)
    }
  }

  renderSection = (activeSection) => {
    const { classes } = this.props;
    if (activeSection <= 0) {
      const today = new Date();
      // Calculate date range
      const pastLimitDate = new Date();
      pastLimitDate.setMonth(today.getMonth() - appConstants.KPI_REPORTS_PAST_MONTHS_LIMIT);

      return (
        <div className={`${classes.subModuleRight} customScroll`}>
          <p className={classes.infoMessage}>Please note: KPI summary is available only for published plans.</p>
          <Grid container className={classes.container}>
            <Grid item md={5} className={classes.chartContainer}>
              <ChartComponent
                onclick={this.fetchReport}
                data={this.getFormatedChartData("milesPerStop")}
                chartConfig={chartConfig["MilesPerStop"]}
                classes={classes}
              />
              <ChartComponent
                data={this.getFormatedChartData("billsPerTrip")}
                chartConfig={chartConfig["BillsPerTrip"]}
                classes={classes}
              />
              <ChartComponent
                onclick={this.fetchReport}
                data={this.getFormatedChartData("totalMiles")}
                chartConfig={chartConfig["Total Miles"]}
                classes={classes}
              />
              <ChartComponent
                onclick={this.fetchReport}
                data={this.getFormatedChartData("missedApts")}
                chartConfig={chartConfig["Missed Apts"]}
                classes={classes}
              />
              <ChartComponent
                onclick={this.fetchReport}
                data={this.getFormatedChartData("totalHours")}
                chartConfig={chartConfig["Total hours"]}
                classes={classes}
              />
            </Grid>
            <Grid item md={5} className={classes.chartContainer}>
              <ChartComponent
                onclick={this.fetchReport}
                data={this.getFormatedChartData("stopsPerHour")}
                chartConfig={chartConfig["StopsPerHour"]}
                classes={classes}
              />
              <ChartComponent
                data={this.getFormatedTotalBillData()} 
                chartConfig={chartConfig["Total Bills"]}
                checked= {this.getCheckboxStatus()}
                classes={classes}
              />
              <ChartComponent
                onclick={this.fetchReport}
                data={this.getFormatedChartData("routes")}
                chartConfig={chartConfig["Routes"]}
                classes={classes}
              />
              <ChartComponent
                onclick={this.fetchReport}
                data={this.getFormatedChartData("stops")}
                chartConfig={chartConfig["Stops"]}
                classes={classes}
              />
            </Grid>

            <Grid item md={1}>
              <div className={classes.chartContainer}>
                <div>
                  <p className={classes.formLabelGreen}>PlanDate</p>
                  <StyledCalendar
                    onChange={this.handleChange("DateRange")}
                    selectedDate={this.state.selectedDate}
                    maxDate={today}
                    minDate={pastLimitDate}
                    clearIcon={null}
                    calendarAriaLabel={"Toggle calendar"}
                  />
                </div>
                <div>
                  <p className={classes.formLabelGreen}>Terminal</p>
                  <div className={classes.selectFilterClass}>
                    <Select
                      textFieldProps={{
                        id: "filterByTerminal",
                        label: null,
                        variant: "outlined",
                      }}
                      value={this.state.terminalCode}
                      isNotClearable= {true}
                      onChange={this.handleChange("selectedTerminal")}
                      data={this.state.terminalList}
                    />
                  </div>
                </div>
                <div>
                  <p className={classes.formLabelGreen}>Module</p>
                  <div className={classes.selectFilterClass}>
                    {this.state.modules.map((moduleObj, index) => (
                      <FormControlLabel
                        key={index}
                        control={
                          <Checkbox
                            checked={moduleObj.isChecked}
                            disabled={moduleObj.disabled}
                            onChange={this.handleChange("selectedModule")}
                            name={moduleObj.name}
                            color="primary"
                            classes={{ root: classes.checkBoxColor }}
                          />
                        }
                        label={<span className={classes.checkBoxLabelStyle}>{moduleObj.name}</span>}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      );
    } else if (activeSection === 1 && this.state.activeChart) {
      const checked = this.getCheckboxStatus()
      return (
        <RouteChart
          goBack={this.goBack}
          chartConfig={chartConfig[`${this.state.activeChart}`]["routeChart"]}
          planDate={this.state.planDate}
          terminal={this.state.terminalCode}
          data={this.getFormatedReportForRoutesData(checked)}
          checked= {checked}
          indexClasses={classes}
        />
      );
    }
  };

  render() {
    return this.renderSection(this.state.activeSection);
  }
}
export default compose(
  withStyles(styles), 
  withUserProfile, 
  withSnackbar, 
  withAppConfig
)(KPISummary);